import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { decode } from 'html-entities';

import { useAppSelector } from 'hooks';
import { useAxios } from 'configs/requests';
import { Error, Loading } from 'components/Fetch';

interface IDeleteSmartEventsModalProps {
  setShow: (show: boolean) => any;
  show: boolean;
  smartEvent: ICarePlanSmartAlert;
  onDeleteSmartEvent: (attribute: string) => any;
  carePlanTemplate?: ICarePlanTemplate;
}

const DeleteSmartEventsModal = ({
  show,
  setShow,
  smartEvent,
  onDeleteSmartEvent,
  carePlanTemplate
}: IDeleteSmartEventsModalProps) => {
  const intl = useIntl();
  const patientUid = useAppSelector(({ patient }) => patient.data?.uid);
  const [error, setError] = useState<any>(false);

  const [{ loading, error: postError }, post] = useAxios(
    {
      url: carePlanTemplate
        ? '/clinician/2.0.0/CarePlanTemplate'
        : `/clinician/Patient/${patientUid}/CarePlan`,
      method: 'POST'
    },
    { manual: true }
  );

  const handleDeleteSmartEvent = async () => {
    const contentToDelete = {
      attribute: smartEvent.attribute,
      attribute_id: smartEvent.attribute_id,
      edit_status: 'deleted'
    };
    await post({
      data: {
        smartEvents: [contentToDelete],
        carePlanTemplate
      }
    });
    onDeleteSmartEvent(smartEvent.attribute);
  };

  useEffect(() => {
    setError(postError);
  }, [postError, setError]);

  return (
    <Modal show={show} onHide={() => setShow(false)} backdrop="static">
      <Modal.Header className="align-items-center">
        <Modal.Title>
          {intl.formatMessage({ id: 'deleteKey' }) +
            ' ' +
            intl.formatMessage({ id: 'smartEventsKey' })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Error retry={handleDeleteSmartEvent} dismissible onClose={() => setError(false)} />
        )}
        <div className="bg-light p-3 font-weight-bolder text-sm">
          {intl.formatMessage({ id: decode(smartEvent.summary) })}
        </div>
        {loading && <Loading className="mt-4" />}
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-test="delete-smart-event-modal-cancel"
          variant="link"
          onClick={() => setShow(false)}
        >
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button
          data-test="delete-smart-event-modal-submit"
          variant="danger"
          onClick={handleDeleteSmartEvent}
        >
          {intl.formatMessage({ id: 'deleteKey' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSmartEventsModal;
